import { StorageEnum } from 'utils/StorageEnum';
import { RateVideoModel } from './model';

export class RateVideoRepository {
  /**
   * @param {string} videoId
   * @param {number} rating
   */
  static persistInSession = (videoId, rating) =>
    sessionStorage.setItem(`${StorageEnum.CT_RATE_VIDEO}${videoId}`, rating.toString());

  /**
   * @param {string} videoId
   * @returns (?RateVideoModel.type)
   */
  static fetchFromSession = (videoId) => {
    const value = sessionStorage.getItem(`${StorageEnum.CT_RATE_VIDEO}${videoId}`);

    if (!value) {
      return null;
    }

    return RateVideoModel({
      videoId,
      value,
    });
  };

  /**
   * @param {string} videoId
   */
  static delete = (videoId) => localStorage.removeItem(`${StorageEnum.CT_RATE_VIDEO}${videoId}`);
}
